export default {
    bind: function (el, binding, vnode) {
        el.addEventListener('click', (e) => {

            if (document.body && document.body.clientWidth) {
                if (document.body.clientWidth <= (el.getAttribute('mobile-input-max-width') || 768)) {
                    let model = binding.expression
                    if (model) {
                        model = _.split(model, '.')

                        vnode.context.$dialog.prompt({
                            confirmText: el.getAttribute('mobile-input-confirm-text') || 'OK',
                            cancelText: el.getAttribute('mobile-input-cancel-text') || 'Cancel',
                            message: el.getAttribute('mobile-input-message'),
                            inputPlaceholder: el.getAttribute('mobile-input-placeholder'),
                            onConfirm: (value) => {
                                if (model[1]) {
                                    vnode.context[model[0]][model[1]] = value
                                } else {
                                    vnode.context[model[0]] = value
                                }
                            }
                        })
                    }
                }
            }
        })
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/directives/MobileInput.js